import { Divider, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const { Item } = Form;
const { required } = formValidatorRules;
const emojiSegmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });

const isSingleEmoji = (value) => {
  if (!value || typeof value !== 'string') return false;
  const text = value?.trim();
  if (!text) return false;
  const segments = Array.from(emojiSegmenter.segment(text), ({ segment }) => segment);
  return segments?.length === 1 && /\p{Extended_Pictographic}/u.test(segments?.[0]);
};

const ConfigTagModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  loadings,
  form,
  tag,
  addScopeLabel,
  isEmojiValue = true,
  nameFieldLabel = 'Name',
  onClose,
}) => {
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    form?.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isModalOpen) {
      return;
    }

    if (tag?.id) {
      form?.setFieldsValue({
        name: tag?.itemKey,
        icon: tag?.value,
        description: tag?.description,
      });
    } else {
      form?.resetFields();
    }
  }, [form, isModalOpen, tag]);

  let modalTitle = 'Add New Tag';
  if (tag?.id) {
    modalTitle = 'Edit Tag';
  } else if (addScopeLabel) {
    modalTitle = `Add ${addScopeLabel} Tag`;
  }

  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={handleCancel}
      onOk={form?.submit}
      title={modalTitle}
      okText="Save"
      confirmLoading={loadings}
      destroyOnClose
      forceRender
      maskClosable={false}
    >
      <Divider />
      <Form
        form={form}
        onFinish={(values) => {
          onFinish(values);
          setIsValidateTrigger(true);
        }}
        autoComplete="off"
        layout="vertical"
        validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
        onFinishFailed={() => setIsValidateTrigger(true)}
      >
        <Item
          label={nameFieldLabel}
          name="name"
          rules={[
            { ...required, message: `Please Enter ${nameFieldLabel}!` },
          ]}
        >
          <Input
            allowClear
            placeholder={`Enter ${nameFieldLabel}`}
            maxLength={100}
          />
        </Item>

        {isEmojiValue ? (
          <Item
            label="Icon"
            name="icon"
            rules={[
              { ...required, message: 'Please Enter Icon!' },
              {
                validator: (_, value) =>
                  !value || isSingleEmoji(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error('Please enter exactly one emoji')),
              },
            ]}
          >
            <Input
              allowClear
              placeholder="Enter one emoji"
              maxLength={8}
              onChange={(e) => {
                const nextValue = e?.target?.value || '';
                if (!nextValue) return;
                const segments = Array.from(emojiSegmenter.segment(nextValue), ({ segment }) => segment);
                if (segments?.length > 1) {
                  form?.setFieldsValue({ icon: segments?.[0] || '' });
                }
              }}
            />
          </Item>
        ) : (
          <Item
            label="Value"
            name="icon"
            rules={[{ ...required, message: 'Please Enter Value!' }]}
          >
            <Input allowClear placeholder="Enter Value" maxLength={100} />
          </Item>
        )}

        <Item
          label="Description"
          name="description"
          rules={[{ ...required, message: 'Please enter a description!' }]}
        >
          <Input.TextArea
            rows={4}
            allowClear
            placeholder="Enter Description"
            maxLength={800}
          />
        </Item>
      </Form>
    </ModalComponent>
  );
};

export default ConfigTagModal;
